import React, { useRef, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import ScrollToTopButton from "../components/ScrollToTopButton";
import Bottle_Img_1 from "../assets/Bottle_Img_1.jpg";
import Bottle_Img_2 from "../assets/Bottle_Img_2.jpg";
import Bottle_Img_3 from "../assets/Bottle_Img_3.jpg";
import Bottle_Img_4 from "../assets/Bottle_Img_4.jpg";
import Bottle_Img_5 from "../assets/Bottle_Img_5.jpg";
import Bottle_Img_6 from "../assets/Bottle_Img_6.jpg";
import Bottle_Img_7 from "../assets/Bottle_Img_7.jpg";
import Bottle_Img_8 from "../assets/Bottle_Img_8.jpg";
import Bottle_Img_9 from "../assets/Bottle_Img_9.jpg";
import Bottle_Img_10 from "../assets/Bottle_Img_10.jpg";
import Bottle_Img_11 from "../assets/Bottle_Img_11.jpg";
import Bottle_Img_12 from "../assets/Bottle_Img_12.jpg";
import Bottle_Img_13 from "../assets/Bottle_Img_13.jpg";
import Bottle_Img_14 from "../assets/Bottle_Img_14.jpg";
import Bottle_Img_15 from "../assets/Bottle_Img_15.jpg";
import Bottle_Img_16 from "../assets/Bottle_Img_16.jpg";
import Bottle_Img_17 from "../assets/Bottle_Img_17.jpg";
import Bottle_Img_18 from "../assets/Bottle_Img_18.jpg";
import Bottle_Img_19 from "../assets/Bottle_Img_19.jpg";
import Bottle_Img_20 from "../assets/Bottle_Img_20.jpg";
import Bottle_Img_21 from "../assets/Bottle_Img_21.jpg";
import Bottle_Img_22 from "../assets/Bottle_Img_22.jpg";
import Bottle_Img_23 from "../assets/Bottle_Img_23.jpg";
import Bottle_Img_24 from "../assets/Bottle_Img_24.jpg";
import Bottle_Img_25 from "../assets/Bottle_Img_25.jpg";
import Bottle_Img_26 from "../assets/Bottle_Img_26.jpg";
import photo1 from "../assets/photo_1.jpg";
import photo2 from "../assets/photo_2.jpg";
import photo3 from "../assets/photo_3.jpg";
import photo4 from "../assets/photo_4.jpg";
import Oreder_1M_Poster from "../assets/1M_Poster.jpg";
import Oreder_4M_Poster from "../assets/4M_Poster.jpg";

const Bottle_Img = [
  Bottle_Img_1,
  Bottle_Img_2,
  Bottle_Img_3,
  Bottle_Img_4,
  Bottle_Img_5,
  Bottle_Img_6,
  Bottle_Img_7,
  Bottle_Img_8,
  Bottle_Img_9,
  Bottle_Img_10,
  Bottle_Img_11,
  Bottle_Img_12,
  Bottle_Img_13,
  Bottle_Img_14,
  Bottle_Img_15,
  Bottle_Img_16,
  Bottle_Img_17,
  Bottle_Img_18,
  Bottle_Img_19,
  Bottle_Img_20,
  Bottle_Img_21,
  Bottle_Img_22,
  Bottle_Img_23,
  Bottle_Img_24,
  Bottle_Img_25,
  Bottle_Img_26,
];

const Blog = () => {
  const blogPosts = [
    {
      title: "EV91Technology Sets Wheels in Motion with New Delhi Expansion",
      date: "June 20, 2025",
      author: "EV91Technologies News Team",
      image: require("../assets/ev91-blogs.jpg"),
      excerpt:
        "EV91Technologies proudly announces the grand opening of its new branch in New Delhi on June 20, 2025. The launch event featured a high-profile press meet, unveiling our commitment to expanding sustainable electric mobility solutions in North India. Discover how our Delhi branch will empower gig workers, drive green logistics, and accelerate the EV revolution. Watch the press meet highlights on YouTube.",
      url: "https://www.franchiseindia.com/insights/en/news/ev91-opens-new-service-center-to-support-ev-operations-in-delhi-ncr.56784",
      youtube: "https://www.youtube.com/watch?v=K9tLq7_laWQ",
    },
    {
      title:
        "EV91 Partners with BattRE and evpe to Launch 10,000 Electric Vehicles for Greener Logistics",
      date: "April 5, 2025",
      author: "EV91Technologies News Team",
      image: require("../assets/blog image-1.jpg"),
      excerpt:
        "EV91, BattRE Electric Mobility, and evpe have joined forces to deploy 10,000 electric two-wheelers in India through a ₹100-crore deal. BattRE will supply the vehicles, evpe will finance them, and EV91 will integrate them into logistics, boosting sustainable last-mile delivery and reducing urban emissions nationwide. ",
      url: "https://www.apnnews.com/ev91-partners-with-battre-to-deploy-10000-electric-vehicles/",
      youtube: "https://youtu.be/kL311gmjlow?feature=shared",
    },
    {
      title:
        "Congratulations EV91TECHNOLOGIES PRIVATE LIMITED for winning at the Karnataka Business Awards 2024!",
      date: "July 2024",
      author: "Karnataka Business Awards",
      image: require("../assets/youtube-thumbnail.jpg"),
      excerpt:
        "We are thrilled to announce that EV91Technologies Private Limited has been honored at the Karnataka Business Awards 2024 for outstanding innovation and leadership in electric mobility and sustainable logistics. This recognition is a testament to our team’s dedication and the trust of our partners and gig workers. Watch the award ceremony highlights on YouTube.",
      url: "https://www.youtube.com/watch?v=7vM4MN07j-M",
      youtube: "https://www.youtube.com/watch?v=7vM4MN07j-M",
    },
    {
      title:
        "EV91Technologies launches brand VOICE and 107 EVs in partnership with BGauss",
      date: "February 2, 2024",
      author: "EV91Technologies News Team",
      image: require("../assets/thumbnail.jpg"),
      excerpt:
        "VOICE (formerly EV91) has partnered with BGauss to deploy 5,000 electric two‑wheelers across India, starting with 107 EVs launched in Bengaluru and Chennai on February 2, 2024. They introduced a new logo and website while offering EV loans, rentals, fleet services, and subscriptions to boost adoption and reach 1,500 EVs by 2024’s end. ",
      url: "https://www.outlookmoney.com/outlook-money-spotlight/voice-partners-with-bgauss-to-deploy-5000-electric-vehicles-launches-new-logo-8951",
    },
  ];

  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    let animationFrame;

    const scrollStep = () => {
      // Scroll faster
      scrollContainer.scrollLeft += 2;
      // When reaching the end of the first set, reset to the start of the set (not 0, but a small offset)
      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 1) {
        scrollContainer.scrollLeft = 5;
      }
      animationFrame = requestAnimationFrame(scrollStep);
    };

    animationFrame = requestAnimationFrame(scrollStep);

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <>
      <Helmet>
        <title>Blogs & News | EV91Technologies (VOICE)</title>
        <meta
          name="description"
          content="Read the latest blogs, news, and updates from EV91Technologies (VOICE) about electric mobility, logistics, gig work, and sustainability in India."
        />
        <meta
          name="keywords"
          content="EV blogs, electric vehicle news, gig work, logistics, sustainability, EV91Technologies, VOICE"
        />
        <meta
          property="og:title"
          content="Blogs & News | EV91Technologies (VOICE)"
        />
        <meta
          property="og:description"
          content="Read the latest blogs, news, and updates from EV91Technologies (VOICE) about electric mobility, logistics, gig work, and sustainability in India."
        />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ev91riderz.com/blog" />
        <link rel="canonical" href="https://ev91riderz.com/blog" />
      </Helmet>
      <section className="relative -mt-6 overflow-hidden bg-slate-950 px-5 py-20 text-white lg:px-8">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(190,242,100,0.18),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(16,185,129,0.2),transparent_40%)]"></div>
        <div className="relative mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.95fr_1.05fr] lg:items-center">
          <div>
            <p className="text-sm font-black uppercase tracking-[0.26em] text-lime-300">EV91 Insights</p>
            <h1 className="mt-4 text-4xl font-black tracking-tight md:text-6xl">
              Stories, milestones, and EV logistics updates from VOICE.
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300">
              Follow our city launches, fleet partnerships, rider stories, awards, and the progress behind cleaner last-mile delivery.
            </p>
          </div>
          <article className="overflow-hidden rounded-[2rem] border border-white/10 bg-white shadow-2xl shadow-black/30">
            <img src={blogPosts[0].image} alt={blogPosts[0].title} className="h-72 w-full object-cover" />
            <div className="p-6 text-slate-950">
              <p className="text-sm font-black uppercase tracking-[0.2em] text-emerald-700">Featured update</p>
              <h2 className="mt-2 text-2xl font-black">{blogPosts[0].title}</h2>
              <a href={blogPosts[0].url} target="_blank" rel="noopener noreferrer" className="mt-5 inline-flex rounded-full bg-slate-950 px-5 py-2.5 font-black text-white transition hover:bg-emerald-700">
                Read latest
              </a>
            </div>
          </article>
        </div>
      </section>

      <section className="hidden">
        {/* Gradient Overlay Circles */}

        <div className="absolute -top-16 -left-16 w-64 h-64 bg-green-400 rounded-full opacity-20 blur-3xl animate-pulse" />
        <div className="absolute -bottom-16 -right-16 w-72 h-72 bg-green-500 rounded-full opacity-20 blur-2xl animate-ping" />

        {/* Content */}
        <div className="relative z-10 max-w-5xl mx-auto text-center">
          <p className="text-sm font-black uppercase tracking-[0.26em] text-lime-300 mb-4">EV91 Insights</p>
          <h1 className="text-4xl md:text-6xl font-black leading-tight mb-6 text-white">
            🌿 Discover the Future with <span className="">Blogs & News</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-100 mb-8">
            Stay updated with the latest trends, innovations, and insights in
            electric mobility, gig economy, and sustainability. Learn how{" "}
            <strong>VOICE</strong> is transforming green transportation and
            empowering gig workers across India.
          </p>
        </div>
      </section>

      <section
        className="py-20 min-h-screen bg-slate-50"
        id="ev91 blogs"
      >
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="grid gap-7 md:grid-cols-2">
            {blogPosts.map((post, idx) => (
              <article
                key={idx}
                className="group flex flex-col overflow-hidden rounded-[2rem] border border-emerald-100 bg-white shadow-xl shadow-slate-900/8 transition duration-300 hover:-translate-y-1 hover:shadow-2xl"
              >
                <img
                  src={post.image}
                  alt={post.title}
                  className="h-64 w-full object-cover transition duration-700 group-hover:scale-105"
                />
                <div className="p-6 flex flex-col flex-1">
                  <h2 className="text-2xl font-black text-slate-950 mb-2 tracking-tight">
                    {post.title}
                  </h2>
                  <div className="flex items-center text-sm text-gray-500 mb-3 space-x-3">
                    <span>{post.date}</span>
                    <span>•</span>
                    <span>{post.author}</span>
                  </div>
                  <p className="text-gray-700 flex-1 mb-4 leading-relaxed">
                    {post.excerpt}
                  </p>
                  <div className="flex flex-wrap gap-3 mt-auto">
                    <a
                      href={post.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-5 py-2.5 rounded-full bg-slate-950 text-white font-black hover:bg-emerald-700 transition"
                    >
                      Read More
                    </a>
                    {post.youtube && (
                      <a
                        href={post.youtube}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-5 py-2.5 rounded-full bg-red-600 text-white font-black hover:bg-red-700 transition"
                      >
                        YouTube
                      </a>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* 1M Celebration */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-8">
          {/* Text Column */}
          <div className="md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left">
            <h4 className="text-3xl md:text-4xl font-bold mb-4 text-green-800 drop-shadow-lg">
              🚀 1 Million Orders in Just 28 Days ⚡
            </h4>
            <h5 className="text-2xl md:text-3xl font-extrabold italic font-serif text-green-800 mb-4 drop-shadow-lg tracking-wide">
              🌿 EV91's Delivery Milestone Celebration 🎉
            </h5>
            <p className="text-lg md:text-xl text-green-900 font-semibold italic leading-relaxed max-w-md">
              Our milestone reflects trust, speed, and collaboration. <br />
              <span className="text-green-700 font-bold">📅 In July 2025</span>,
              we fulfilled over 1 million orders across{" "}
              <span className="text-green-700 font-bold">
                📍 Bengaluru, Hyderabad, Chennai and other cities
              </span>{" "}
              —{" "}
              <span className="text-green-600 font-bold">
                💚 showing that clean, efficient electric mobility is possible
                at scale.
              </span>
            </p>
          </div>

          {/* Image Column */}
          <div className="p-4 flex justify-center md:justify-end">
            <img
              src={Oreder_1M_Poster}
              alt="1 Million Orders Celebration Poster"
              className="w-68 md:w-80 lg:w-96 h-auto rounded-2xl shadow-lg border border-green-200"
            />
          </div>
        </div>
      </section>

      {/*4M Celebration */}
      <section className="py-16 bg-slate-50">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-evenly gap-20">
          {/* Image Column */}
          <div className="flex justify-center md:justify-start">
            <img
              src={Oreder_4M_Poster}
              alt="EV91 Q1 to Q2 Growth Chart"
              className="w-56 md:w-80 lg:w-96 h-auto rounded-2xl shadow-lg border border-green-200"
            />
          </div>

          {/* Text Column */}
          <div className=" flex flex-col items-center md:items-start text-center md:text-left max-w-md">
            <h4 className="text-2xl md:text-3xl font-bold mb-3 text-green-800 drop-shadow-lg">
              ⚡ From Vision to Velocity — EV91’s Leap from Q1 to Q2! ⚡
            </h4>

            <p className="text-base md:text-lg text-green-900 font-semibold italic leading-relaxed mb-3">
              In Q1 FY25, we started with a mission to drive sustainable
              mobility deeper into India’s last-mile ecosystem. By Q2 FY25, that
              mission turned into momentum. 🌱
            </p>

            <p className="text-base md:text-lg text-green-900 font-semibold italic leading-relaxed">
              Our orders grew from{" "}
              <span className="font-bold text-green-700">
                2.6M → 4.16M (+60%)
              </span>
              , revenue increased{" "}
              <span className="font-bold text-green-700">1.6×</span>, the rider
              community expanded from{" "}
              <span className="font-bold text-green-700">
                3,555 → 5,900 (+66%)
              </span>
              , and our EV91 family grew from{" "}
              <span className="font-bold text-green-700">
                70 → 135 employees (+93%)
              </span>
              . Every milestone represents people, trust, and impact. 💚
            </p>
          </div>
        </div>
      </section>
      {/* Two Years of Teamwork & Triumphs */}
      <section className="py-16 bg-gradient-to-br from-green-50 via-white to-blue-50">
  <div className="container mx-auto px-4">
    {/* Blog Header */}
    <div className="text-center mb-10">
      <h2 className="text-3xl md:text-4xl font-bold text-green-800 mb-2">
        ✨ Two Years of Teamwork & Triumphs ✨
      </h2>
      <p className="text-gray-600 font-medium max-w-2xl mx-auto">
        A heartfelt shoutout to our unstoppable EV91 Technologies team – the
        driving force behind every milestone, every laugh, and every success.
      </p>
    </div>

    {/* Blog Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
      {/* Left: Blog Content */}
      <div className="space-y-4 text-green-900">
        <p className="text-lg leading-relaxed">
          Here’s to my amazing team 👏 – you’re the reason we’ve come this far
          and the energy behind every success. 🚀
        </p>
        <p className="text-lg leading-relaxed">
          At <span className="font-semibold text-green-700">EV91 Technologies Pvt Ltd</span>,
          we believe in more than just hard work — we believe in celebrating
          every milestone together. 💯
        </p>
        <p className="text-lg leading-relaxed">
          From thrilling adventure rides to laughter-filled office moments,
          our journey has been about growth, fun, and unbeatable team spirit.
        </p>
        <p className="text-lg font-semibold italic text-green-800">
          Cheers to many more milestones, memories, and celebrations together! 🥂💙
        </p>

        {/* Hashtags */}
        <div className="flex flex-wrap gap-2 mt-4 text-sm">
          {[
            "#EV91Technologies",
            "#TeamSpirit",
            "#WorkAndPlay",
            "#FoundersJourney",
            "#AnniversaryCelebration",
            "#2YearsStrong",
            "#Motivation",
            "#Leadership",
            "#StartUpLife",
          ].map((tag) => (
            <span
              key={tag}
              className="bg-green-100 text-green-700 px-3 py-1 rounded-full font-medium hover:bg-green-200 transition"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* Right: 4-Photo Gallery */}
      <div className="grid grid-cols-2 gap-4">
        <img
          src={photo1}
          alt="Team Celebration"
          className="rounded-2xl shadow-md hover:scale-105 transition-transform duration-300"
        />
        <img
          src={photo2}
          alt="Adventure Ride"
          className="rounded-2xl shadow-md hover:scale-105 transition-transform duration-300"
        />
        <img
          src={photo3}
          alt="Team Fun"
          className="rounded-2xl shadow-md hover:scale-105 transition-transform duration-300"
        />
        <img
          src={photo4}
          alt="Milestone Celebration"
          className="rounded-2xl shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>
    </div>
  </div>
</section>
      {/* Clients Section */}
      <section className="py-16 animate-jump-right">
        <div className="container mx-auto px-4">
          <div className="w-full bg-gradient-to-r from-green-100 via-white to-green-50 py-8 px-2 md:px-8 flex flex-col items-center justify-center mb-8">
            <h4 className="text-3xl md:text-4xl font-bold mb-8 text-center text-green-800 drop-shadow-lg">
              🛵 Ride. 💧 Refresh. 🔁 Repeat.
            </h4>
            <h5 className="text-2xl md:text-3xl font-extrabold italic font-serif text-green-800 mb-4 drop-shadow-lg tracking-wide">
              🌿 EV91's Water Bottle Campaign 🚰
            </h5>
            <p className="text-lg md:text-2xl text-green-900 font-semibold italic leading-relaxed text-center max-w-4xl mx-auto">
              Our campaign reinforced our commitment to rider well-being. <br />
              <span className="text-green-700 font-bold">📅 In May 2025</span>,
              we distributed thousands of bottles across{" "}
              <span className="text-green-700 font-bold">
                📍 Bengaluru, Hyderabad and Chennai
              </span>{" "}
              to keep riders hydrated during the summer heat —{" "}
              <span className="text-green-600 font-bold">
                💚 a small act of care with a big impact.
              </span>
            </p>
          </div>

          <div
            ref={scrollRef}
            className="flex overflow-x-auto py-6 px-2 md:px-8 gap-8 scrollbar-hide rounded-2xl bg-gradient-to-r from-green-50 via-white to-green-100 shadow-lg border border-green-100"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              scrollBehavior: "auto",
              scrollbarWidth: "none",
              WebkitOverflowScrolling: "touch",
              scrollbarColor: "transparent transparent",
              msOverflowStyle: "none",
            }}
          >
            {/* Repeat logos 4 times for a longer seamless loop */}
            {[...Bottle_Img, ...Bottle_Img, ...Bottle_Img, ...Bottle_Img].map(
              (logo, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 flex justify-center items-center transition-transform duration-300 hover:scale-105"
                  style={{ width: "220px", height: "220px" }}
                >
                  <img
                    src={logo}
                    alt={`Client ${index + 1}`}
                    className="h-[200px] w-[200px] object-contain rounded-xl shadow-md bg-white transition-transform duration-500 hover:scale-110 hover:shadow-2xl border border-green-200"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
              )
            )}
          </div>
        </div>
      </section>

      <ScrollToTopButton />
    </>
  );
};

export default Blog;



